import { createReducer } from '@reduxjs/toolkit';
import { changeSystemLanguage } from './actions';
import { systemInitialState } from './state';

export const systemReducer = createReducer(systemInitialState, (builder) => {
  builder.addCase(changeSystemLanguage, (state, { payload }) => {
    state.language = payload;
  });
});
